import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_KPI_SEL = {
	'5G': ['SERVICE DR', 'DATA PRBS USED BY PDSCH', 'AVAILABILITY'],
	'4G': ['VDCR', 'VOICE TRAFFIC', 'AVAILABILITY'],
	'3G': ['VDCR', 'VOICE TRAFFIC', 'AVAILABILITY'],
	'2G': ['VDCR', 'VOICE TRAFFIC', 'AVAILABILITY'],
};

const filtersSlice = createSlice({
	name: 'filters',
	initialState: {
		aggLevel:         'Activity',
		dateFrom:         '',
		dateTo:           '',
		// All multi-select filters are arrays
		operator:         [],
		vendor:           [],
		layer:            [],
		siteId:           [],
		server:           [],
		tac:              [],
		tech1:            null,
		tech2:            null,
		kpiSel:           DEFAULT_KPI_SEL,
		selectedEntities: {},  // { tech: [entityId, ...] }
		numCharts:        3,
	},
	reducers: {
		setAggLevel(state, action)           { state.aggLevel         = action.payload; },
		setDateFrom(state, action)           { state.dateFrom         = action.payload; },
		setDateTo(state, action)             { state.dateTo           = action.payload; },
		setOperator(state, action)           { state.operator         = action.payload; },
		setVendor(state, action)             { state.vendor           = action.payload; },
		setLayer(state, action)              { state.layer            = action.payload; },
		setSiteId(state, action)             { state.siteId           = action.payload; },
		setServer(state, action)             { state.server           = action.payload; },
		setTac(state, action)                { state.tac              = action.payload; },
		setTech2(state, action)              { state.tech2            = action.payload; },
		setNumCharts(state, action)          { state.numCharts        = action.payload; },
		// payload: { tech, entities } or {} to clear all
		setSelectedEntities(state, action) {
			const { tech, entities } = action.payload;
			if (tech) state.selectedEntities[tech] = entities;
			else      state.selectedEntities = {};
		},

		setDatesFromActivity(state, action) {
			const today   = new Date().toISOString().slice(0, 10);
			const pad     = (d) => new Date(d).toISOString().slice(0, 10);
			const rawFrom = action.payload.startDate ?? today;
			const rawTo   = action.payload.endDate   ?? today;
			const dFrom = new Date(rawFrom); dFrom.setDate(dFrom.getDate() - 7);
			const dTo   = new Date(rawTo);   dTo.setDate(dTo.getDate() + 7);
			state.dateFrom = pad(dFrom);
			state.dateTo   = pad(dTo);
			if (action.payload.technology) state.tech1 = action.payload.technology;
		},

		setKpiSlot(state, action) {
			const { tech, slot, kpiName } = action.payload;
			state.kpiSel[tech][slot] = kpiName;
		},

		resetFilters(state) {
			state.aggLevel         = 'Activity';
			state.operator         = [];
			state.vendor           = [];
			state.layer            = [];
			state.siteId           = [];
			state.server           = [];
			state.tac              = [];
			state.tech2            = null;
			state.selectedEntities = {};
		},
	},
});

export const {
	setAggLevel, setDateFrom, setDateTo,
	setOperator, setVendor, setLayer, setSiteId, setServer, setTac, setTech2,
	setDatesFromActivity, setKpiSlot, resetFilters,
	setNumCharts, setSelectedEntities,
} = filtersSlice.actions;

export default filtersSlice.reducer;